import { gql } from "@apollo/client";

export const getMaterialCategory = gql`
  query searchMaterialCategoryMaster($keyword: String) {
    searchMaterialCategoryMaster(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
    }
  }
`;

export let getLPCSAccount = gql`
  query SearchAccounts($keyword: String, $accountType: String = "Customer Account") {
    SearchAccounts(keyword: $keyword, Account_Type: $accountType) {
      _id
      UserId
      Search_Value
      Business_Name
      Proprietor_Name
      Mobile_Number
      Business_Name
      Account_Type
    }
  }
`;

export let getSPCSUsers = gql`
  query CS_SearchUsers(
    $keyword: String
    $accType: String = "Supply Partner Account"
    $Type_Of_User: String = "Root_User"
  ) {
    CS_SearchUsers(keyword: $keyword, accType: $accType, Type_Of_User: $Type_Of_User) {
      _id
      Unique_Id
      Company_Name
      Search_Value
      mobileNumber
    }
  }
`;
const userData = JSON.parse(sessionStorage.getItem("userData"));

export let getLoadManagersForMyLoads = gql`
  query CS_SearchAndRetrieveSubUsersGetAccountManagers($keyword: String, $SearchId: ID = "${
    userData ? userData?.userDetails[0]?.User_ID : ""
  }") {
    CS_SearchAndRetrieveSubUsersGetAccountManagers(keyword: $keyword, Root_User_Id: $SearchId) {
      _id
      Search_Value
      FullName
    }
  }
`;

export const SearchVehicles = gql`
  query GetVehicleManagementDetailsByUserId($SearchId: ID, $keyword: String) {
    GetVehicleManagementDetailsByUserId(UserId: $SearchId, keyword: $keyword) {
      Search_Value
      _id
    }
  }
`;

const Loadfilds = [
  {
    id: Math.random() * 10,
    name: "Load_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Loading_Name",
        label: "From Location",
        type: "InputDropForQuery",
        masterName: "SearchPlaceMaster",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Name",
        label: "To Location",
        type: "InputDropForQuery",
        masterName: "SearchPlaceMaster",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Payment_Percentage",
        type: "inputdrop",
        dropdowncontent: [75, 80, 90],
        min: 1,
        max: Infinity,
        isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Date",
        type: "Date",
        isRequired: true,
        restrictDateRange: true,
        validate_key: "Date_Feature",
        restrictDateRange: true,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Time",
        label: "Loading Time",
        type: "time",
        dropdowncontent: ["8:00 Am", "8:30 Am", "9:00 Am", "9:30 Am", "9:30 Am"],
        min: 1,
        max: Infinity,
        // isRequired:true,
      },
      {
        id: Math.random() * 10,
        name: "Post_Frequency",
        type: "inputdrop",
        dropdowncontent: ["One Time", "Daily"],
        min: 1,
        max: Infinity,
        // isRequired:true,
        value: "One Time",
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Load_Live_Days",
        type: "inputdrop",
        dropdowncontent: ["15 Days", "30 Days"],
        min: 1,
        max: Infinity,
        dependOn: {
          section: "Load_Details",
          name: "Post_Frequency",
          visibleOn: "Daily",
          default: "15 Days",
        },
        notSearchable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Loading_Point",
    fields: [
      {
        id: Math.random() * 10,
        name: "Loading_Landmark",
        type: "text",
        min: 1,
        max: Infinity,
        disable: true,
        // isRequired:true,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Area",
        // setvalue: "Area",
        type: "text",
        min: 1,
        max: Infinity,
        // isRequired:true,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Pincode",
        type: "number",
        hasApiCallback: "true",
        disable: true,
        min: 6,
        max: 6,
        isRequired: false,
      },

      {
        id: Math.random() * 10,
        name: "Loading_City",
        setvalue: "City",
        disable: true,
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
      },
      {
        id: Math.random() * 10,
        name: "Loading_State",
        setvalue: "State",
        disable: true,
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Address_Line_1",
        label: "Loading Address",
        setvalue: "Towns",
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
        disable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Unloading_Point",
    fields: [
      {
        id: Math.random() * 10,
        name: "Unloading_Landmark",
        type: "text",
        min: 2,
        max: Infinity,
        disable: true,
        // isRequired:true,
        disable: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Area",
        setvalue: "Area",
        type: "text",
        min: 2,
        max: Infinity,
        // isRequired:true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Pincode",
        type: "number",
        hasApiCallback: "true",
        min: 6,
        max: 6,
        isRequired: false,
        disable: true,
      },

      {
        id: Math.random() * 10,
        name: "Unloading_City",
        setvalue: "City",
        disable: true,
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_State",
        setvalue: "State",
        disable: true,
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Address_Line_1",
        label: "Unloading Address",
        setvalue: "Towns",
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
        disable: true,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Material_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Material_Category",
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Exact_Content",
        label: "Content",
        type: "text",
        min: 2,
        max: Infinity,
        isRequired: false,
      },
      {
        id: Math.random() * 10,
        name: "Total_Weight",
        label: "Total Weight (MT)",
        type: "number",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Over_Dimension_Cargo",
        label: "Over Dimension",
        type: "inputdrop",
        dropdowncontent: ["Yes", "No"],
        min: 1,
        max: Infinity,
        isRequired: false,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Material_Dimension",
        label: "Material Dimension(L×W×H)",
        type: "inputMask",
        dependOn: {
          section: "Material_Details",
          name: "Over_Dimension_Cargo",
          visibleOn: "Yes",
        },
        mask: "99 x *9 x*9",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Material_Dimension_In",
        label: "Material Dimension's In",
        type: "inputdrop",
        autoComplete: "off",
        dropdowncontent: ["Feet (Ft)", "Meter (Mt)"],
        dependOn: {
          section: "Material_Details",
          name: "Over_Dimension_Cargo",
          visibleOn: "Yes",
        },

        notSearchable: true,
        autoEveryCapital: true,
      },
      {
        id: Math.random() * 10,
        name: "Dangerous_Goods",
        type: "inputdrop",
        dropdowncontent: ["Yes", "No"],
        min: 1,
        max: Infinity,
        isRequired: false,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Material_Insurence",
        label: "Material Insurance",
        type: "inputdrop",
        dropdowncontent: ["Yes", "No"],
        notSearchable: true,
        min: 1,
        max: Infinity,
        isRequired: false,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Load_Type",
    label: "Load_Type",
    fields: [
      {
        id: Math.random() * 10,
        name: "Load_Type",
        label: "Load Type",
        type: "inputdrop",
        autoComplete: "off",
        isRequired: true,
        notSearchable: true,
        dropdowncontent: ["FTL", "PTL (Part Load)"],
      },
      {
        id: Math.random() * 10,
        name: "Load_Post_Type",
        label: "Select Load Post Type",
        placeholder: "Load Live Duration",
        type: "inputdrop",
        autoComplete: "off",
        // dependsOn: {
        //   field: "Load_Type",
        //   value: "FTL",
        // },
        isRequired: true,
        notSearchable: true,
        dropdowncontent: ["Open Load", "Fixed Load"],
      },
      {
        id: Math.random() * 10,
        name: "Load_Manager",
        label: "Load Manager",
        placeholder: "Load Manager",
        masterName: "MyLoadsLoadManager",
        type: "InputDropForQuery",
        isRequired: true,
        dropdowncontent: getLoadManagersForMyLoads,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
      },
      {
        id: Math.random() * 10,
        name: "Load_Live_Duration",
        label: "Load Live Duration",
        placeholder: "Load Live Duration",
        type: "inputdrop",
        dependOn: {
          section: "Load_Details",
          name: "Post_Frequency",
          visibleOn: "One Time",
          default: "12hr",
        },
        autoComplete: "off",
        // isRequired: true,
        notSearchable: true,
        dropdowncontent: ["6hr", "12hr", "18hr", "24hr"],
      },
      {
        id: Math.random() * 10,
        name: "Rate_per",
        label: "Rate per",
        placeholder: "Rate per",
        type: "inputdrop",
        autoComplete: "off",
        notSearchable: true,
        isRequired: true,
        autoEveryCapital: true,
        dropdowncontent: ["Per Vehicle", "Per MT"],
      },
      {
        id: Math.random() * 10,
        name: "No_Of_Vehicels_Required",
        label: "No Of Vehicels Require",
        placeholder: "No Of Vehicels Required",
        type: "inputdrop",
        isRequired: false,
        autoComplete: "off",
        notSearchable: true,
        // isSearchable: false,
        dropdowncontent: [1, 2, 3],
      },
      {
        id: Math.random() * 10,
        name: "Target_Price",
        label: "Target Price (₹)",
        type: "number",
        isSearchable: false,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Vehicle_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_Category",
        type: "inputdrop",
        dropdowncontent: [
          "Trailer Dala Body",
          "Trailer Flat Bed ",
          "Open Body Truck",
          "Container",
          "Tanker",
          "Tipper",
          "Bulker",
          "Dumper",
        ],
        min: 1,
        max: Infinity,
        notSearchable: true,
      },
    ],
  },
];

const BidDetailsFields = [
  {
    id: Math.random() * 10,
    name: "User_Details_For_Bid",
    fields: [
      {
        id: Math.random() * 10,
        name: "UserId",
        label: "Account",
        masterName: "SPCSUsers",
        type: "InputDropForQuery",
        dropdowncontent: getSPCSUsers,
        min: 1,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Bid",
        label: "Bid Price",
        type: "number",
        min: 1,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

const BidFields = [
  {
    id: Math.random() * 10,
    name: "Bidding_Fields",
    fields: [
      {
        id: Math.random() * 10,
        name: "No_Of_Vehicles",
        label: "No_Of_Vehicles",
        type: "inputdrop",
        autoComplete: "off",
        require: true,
        notSearchable: true,
        // isSearchable: false,
        dropdowncontent: ["1", "2", "3"],
      },
    ],
  },
];

const VehicleFields = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Fields",
    fields: [
      {
        id: Math.random() * 10,
        name: "Select_Vehicle",
        label: "Select Vehicle's",
        masterName: "Vehicles",
        type: "InputDropForQuery",
        autoComplete: "off",
        Reference_field: "UserId",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        require: true,
        isSearchable: true,
        dropdowncontent: SearchVehicles,
      },
      {
        id: Math.random() * 10,
        name: "Enter_Quantity",
        label: "Enter Quantity",
        type: "number",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

const VehicleFields2 = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Fields2",
    fields: [
      {
        id: Math.random() * 10,
        name: "Select_Vehicle2",
        label: "Select Vehicle's",
        type: "InputDropForQuery",
        autoComplete: "off",
        masterName: "Vehicles",
        Reference_field: "UserId",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        require: true,
        isSearchable: true,
        dropdowncontent: SearchVehicles,
      },
      {
        id: Math.random() * 10,
        name: "Enter_Quantity",
        label: "Enter Quantity",
        type: "number",
        min: 1,
        max: Infinity,
      },
    ],
  },
];
const VehicleFields3 = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Fields3",
    fields: [
      {
        id: Math.random() * 10,
        name: "Select_Vehicle3",
        label: "Select Vehicle's",
        type: "InputDropForQuery",
        autoComplete: "off",
        masterName: "Vehicles",
        Reference_field: "UserId",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        require: true,
        isSearchable: true,
        dropdowncontent: SearchVehicles,
      },
      {
        id: Math.random() * 10,
        name: "Enter_Quantity",
        label: "Enter Quantity",
        type: "number",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

const Textareadata = [
  {
    id: Math.random() * 10,
    name: "Note_Data",
    fields: [
      {
        id: Math.random() * 10,
        name: "Bid_Note",
        label: "Bid Note",
        type: "textarea",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

const DocUpload = {
  name: "Documents",
  label: "Other Details",
  fields: [
    {
      id: Math.random() * 10,
      name: "Material_Image",
      label: "Material Image 1",
    },
    {
      id: Math.random() * 10,
      name: "Material_Image_2",
      label: "Material Image 2",
    },
    {
      id: Math.random() * 10,
      name: "Material_Image_3",
      label: "Material Image 3",
    },
  ],
};

// const OpenLoadData = {
//   id: Math.random() * 10,
//   name: "Open_Load",
//   label: "Open_Load",
//   fields: [
//     {
//       id: Math.random() * 10,
//       name: "Load_Live_Duration",
//       label: "Load Live Duration",
//       placeholder: "Load Live Duration",
//       type: "inputdrop",
//       autoComplete: "off",
//       // isRequired: true,
//       isSearchable: true,
//       dropdowncontent: ["1HR", "2HR", "4HR", "6HR", "12HR", "24HR"],
//     },
//     {
//       id: Math.random() * 10,
//       name: "Load_Manager",
//       label: "Load Manager",
//       placeholder: "Load Manager",
//       type: "InputDropForQuery",
//       Reference_field: "UserId",
//       // isRequired: true,
//       dropdowncontent: getLoadManagers,
//     },
//     {
//       id: Math.random() * 10,
//       name: "Rate_per",
//       label: "Rate per",
//       placeholder: "Rate per",
//       type: "inputdrop",
//       autoComplete: "off",
//       isSearchable: true,
//       // isRequired: true,
//       autoEveryCapital: true,
//       dropdowncontent: ["Per Vehicle", "Per MT"],
//     },
//     {
//       id: Math.random() * 10,
//       name: "No_Of_Vehicels_Required",
//       label: "No Of Vehicels Require",
//       placeholder: "No Of Vehicels Required",
//       type: "inputdrop",
//       // isRequired: true,
//       autoComplete: "off",
//       notSearchable: true,
//       // isSearchable: false,
//       dropdowncontent: [1, 2, 3],
//     },
//     {
//       id: Math.random() * 10,
//       name: "Target_Price",
//       label: "Target Price (₹)",
//       type: "number",
//       isSearchable: false,
//     },
//   ],
// };

// const FixedLoadData = {
//   id: Math.random() * 10,
//   name: "Fixed Load",
//   label: "Fixed Load",
//   fields: [
//     {
//       id: Math.random() * 10,
//       name: "Load_Live_Duration",
//       label: "Load Live Duration",
//       placeholder: "Load Live Duration",
//       type: "inputdrop",
//       autoComplete: "off",
//       require: true,
//       // isRequired: true,
//       isSearchable: true,
//       dropdowncontent: ["1HR", "2HR", "4HR", "6HR", "12HR", "24HR"],
//     },
//     {
//       id: Math.random() * 10,
//       name: "Load_Manager",
//       label: "Load Manager",
//       placeholder: "Load Manager",
//       type: "InputDropForQuery",
//       // isRequired: true,
//       Reference_field: "UserId",
//       dropdowncontent: getLoadManagers,
//     },
//     {
//       id: Math.random() * 10,
//       name: "Rate_per",
//       label: "Rate per",
//       placeholder: "Rate per",
//       type: "inputdrop",
//       autoComplete: "off",
//       isSearchable: true,
//       // isRequired: true,
//       // require: true,
//       autoEveryCapital: true,
//       dropdowncontent: ["Per Vehicle", "Per MT"],
//     },
//     {
//       id: Math.random() * 10,
//       name: "No_Of_Vehicels_Required",
//       label: "No Of Vehicels Require",
//       placeholder: "No Of Vehicels Required",
//       type: "inputdrop",
//       autoComplete: "off",
//       // isRequired: true,
//       // isSearchable: false,
//       notSearchable: true,
//       // require: true,
//       dropdowncontent: [1, 2, 3],
//     },
//     {
//       id: Math.random() * 10,
//       name: "Target_Price",
//       label: "Target Price (₹)",
//       type: "number",
//       // require: true,
//       isSearchable: false,
//     },
//   ],
// };

export {
  BidDetailsFields,
  // OpenLoadData,
  // FixedLoadData,
  BidFields,
  DocUpload,
  Loadfilds,
  Textareadata,
  VehicleFields,
  VehicleFields2,
  VehicleFields3,
};
